export default {
    appReadyToInstall(state) {
        state.install = true;
    },
};